
import templateUrl from "./user-permission-editor-modal.component.html";

export const UserPermissionEditorModalComponent = {
    templateUrl,
    bindings: {
        resolve: "<",
        dismiss: "&",
        close: "&"
    },
    controller: class {
        constructor(permissionGrantService, utilityService) {
            'ngInject'
            this.permissionGrantService = permissionGrantService;
            this.utilityService = utilityService;
        }

        $onChanges() {
            this.user = this.resolve.user || {};
            this.permissionGrant = this.resolve.permissionGrant || {};
            this.permissionDescriptions = this.resolve.permissionDescriptions || [];
            this.permission = this.permissionDescriptions.find(p => this.permissionGrant.Key === p.Key);
        }

        onSave() {
            const saving = this.permissionGrantService.setUserPermission(this.user.EmployeeID, this.permission.Key, {
                Value: this.permissionGrant.Value
            });
            this.utilityService.showLoadingUntilResolved(
                this.utilityService.alertOnError(saving, "Saving failed")
            )
            saving.then(() => {
                this.close({
                    $value: {
                        permissionGrant: {
                            Key: this.permission.Key,
                            Value: this.permissionGrant.Value
                        }
                    }
                });
            });
        }
    }
}
export const UserPermissionEditorModal = {
    component: "apexUserPermissionEditorModal",
    windowClass: 'xx-dialog pagespinner',
    size: 'sm',
    backdrop: 'static'
};
